
<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">Session ending soon</h4>
    </div>
    <div class="modal-body">
      <div class="alert alert-danger" *ngIf="!showLoginPopupSuccessful">Could not show login page.  Please try again or check your popup blocker.</div>
      <p *ngIf="loginService.sessionTimeRemaining &gt; 0">Your session will end in {{ loginService.sessionTimeRemaining }} seconds.</p>
      <p *ngIf="loginService.sessionTimeRemaining &lt;= 0">Your session has ended.</p>
    </div>
    <div class="modal-footer">
      <div class="btn-group">
        <button class="btn btn-outline-secondary" type="button" (click)="close()"><span class="oi oi-x oi-pb-1"></span> Close</button>
        <button class="btn btn-success" *ngIf="loginService.sessionTimeRemaining &gt; 0" type="button" (click)="loginService.renew()"><span class="oi oi-reload"></span> Renew Session</button>
        <button class="btn btn-success" *ngIf="loginService.sessionTimeRemaining &lt;= 0" type="button" (click)="tryLoggingIn()"><span class="oi oi-reload"></span> Log In</button>
      </div>
    </div>
  </div>
</div>